// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "timer-3veSP";
var _3 = "sliding-3SPQ_";
var _4 = "slideUp-1NDUy";
var _5 = "link-1JW0L";
var _6 = "sent-fX2Bc";
var _7 = "wait-1U5P_";
export { _1 as "__esModule", _2 as "timer", _3 as "sliding", _4 as "slideUp", _5 as "link", _6 as "sent", _7 as "wait" }
export default { "__esModule": _1, "timer": _2, "sliding": _3, "slideUp": _4, "link": _5, "sent": _6, "wait": _7 }
